module.exports = __webpack_public_path__ + "static/colgadas-011-be600ee1de32ec678522dd2c1bdd37be.jpg";